import axios from 'axios';

class RegistrationCounter {
  constructor(element) {
    this.blockElement = element;
    this.apiUrl = this.blockElement.dataset.api || null;
    this.showTitleMode = this.blockElement.dataset.showTitle || 'closed-only';
    this.currentRegister = this.blockElement.querySelector(
        '.registration-count-block__currentRegistration'
    );
    this.maxRegister = this.blockElement.querySelector(
        '.registration-count-block__maxRegistration'
    );
    this.titleAlwaysEl = this.blockElement.querySelector(
        '.registration-count-block__titleAlways'
    );
    this.statusLabel = this.blockElement.querySelector(
        '.registration-count-block__state'
    );
    this.beforeRegistrationLabel = this.blockElement.dataset.labelBefore || 'Rejestracja rozpocznie się';
    this.registrationEndedLabel = this.blockElement.dataset.labelEnded || 'Rejestracja zakonczona';
    this.htmlElement = document.documentElement;
    this.langAttribute = this.htmlElement.lang;
    this.languageCode = this.langAttribute
        ? this.langAttribute.substring(0, 2)
        : 'pl';
  }

  init() {
    if (!this.apiUrl || !this.currentRegister || !this.maxRegister) {
      console.error(
          'Brak atrybutu data-api lub elementu <span> w bloku.',
          this.blockElement
      );
      return;
    }

    this.fetchData();
  }

  async fetchData() {
    const fullApiUrl = `${this.apiUrl}${this.languageCode}`;
    const countsWrapper = this.blockElement.querySelector('.registration-count-block__counts');
    const hiddenLabel = this.blockElement.querySelector('.registration-count-block__closed');
    const titleElement = this.blockElement.querySelector(
        '.registration-count-block__closed .registration-count-block__title'
    );

    try {
      const response = await axios.get(fullApiUrl);
      const title = response.data && response.data.title ? String(response.data.title).trim() : '';
      const registrationStartDate = response.data && response.data.registrationStartDate
        ? new Date(response.data.registrationStartDate)
        : null;
      const registrationEndDate = response.data && response.data.registrationEndDate
        ? new Date(response.data.registrationEndDate)
        : null;
      const completedCount = response.data && response.data.completedRegistrationsCount
        ? response.data.completedRegistrationsCount
        : 0;
      const limitCount = response.data && response.data.registrationLimit
        ? response.data.registrationLimit
        : 0;
      const now = new Date();
      const beforeRegistration = registrationStartDate instanceof Date && !Number.isNaN(registrationStartDate.getTime()) && now < registrationStartDate;
      const registrationEnded = (registrationEndDate instanceof Date && !Number.isNaN(registrationEndDate.getTime()) && now >= registrationEndDate) || (limitCount > 0 && completedCount >= limitCount);

      const resetStateLabels = () => {
        if (this.statusLabel) {
          this.statusLabel.textContent = '';
          this.statusLabel.style.display = 'none';
        }
      };

      const showStateLabel = (text) => {
        if (countsWrapper) countsWrapper.style.display = 'none';
        if (hiddenLabel) hiddenLabel.style.display = 'none';
        if (titleElement) titleElement.textContent = '';
        if (this.titleAlwaysEl) {
          this.titleAlwaysEl.textContent = '';
          this.titleAlwaysEl.style.display = 'none';
        }

        if (this.statusLabel) {
          this.statusLabel.textContent = text;
          this.statusLabel.style.display = 'inline';
        }
      };

      if (beforeRegistration) {
        let formattedStart = '';
        if (registrationStartDate instanceof Date && !Number.isNaN(registrationStartDate.getTime())) {
          const locale = this.langAttribute || 'pl-PL';
          try {
            formattedStart = new Intl.DateTimeFormat(locale, {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            }).format(registrationStartDate);
          } catch (e) {
            // Fallback to ISO string on any Intl formatting issues
            formattedStart = registrationStartDate.toLocaleString();
          }
        }

        const beforeText = formattedStart ? `${this.beforeRegistrationLabel} ${formattedStart}` : this.beforeRegistrationLabel;
        showStateLabel(beforeText);
        return;
      }

      if (registrationEnded) {
        showStateLabel(this.registrationEndedLabel);
        return;
      }

      // Open state
      if (countsWrapper) countsWrapper.style.display = 'inline';
      if (hiddenLabel) hiddenLabel.style.display = 'none';
      if (titleElement) titleElement.textContent = '';
      resetStateLabels();

      // Handle always-visible title (open state only)
      if (this.showTitleMode === 'always') {
        if (this.titleAlwaysEl && title) {
          this.titleAlwaysEl.textContent = ` - ${title}`;
          this.titleAlwaysEl.style.display = 'inline';
        } else if (this.titleAlwaysEl) {
          this.titleAlwaysEl.textContent = '';
          this.titleAlwaysEl.style.display = 'none';
        }
      } else if (this.titleAlwaysEl) {
        this.titleAlwaysEl.textContent = '';
        this.titleAlwaysEl.style.display = 'none';
      }

      if (response.data && response.data.completedRegistrationsCount !== undefined) {
        const count = response.data.completedRegistrationsCount;
        const formattedCount = new Intl.NumberFormat('pl-PL').format(count);
        this.currentRegister.textContent = formattedCount;
      }

      if (response.data && response.data.registrationLimit !== undefined) {
        const count = response.data.registrationLimit;
        const formattedCount = new Intl.NumberFormat('pl-PL').format(count);
        this.maxRegister.textContent = formattedCount;
      }
    } catch (error) {
      console.error(`Błąd podczas pobierania danych z ${fullApiUrl}:`, error.message);
      this.currentRegister.textContent = '0';
      this.maxRegister.textContent = '0';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
      .querySelectorAll('.registration-count-block')
      .forEach((blockElement) => {
        const instance = new RegistrationCounter(blockElement);

        instance.init();
      });
});